export default {
  root: {
    colorOne: '{primary.500}',
    colorTwo: '{primary.500}',
    colorThree: '{primary.500}',
    colorFour: '{primary.500}',
  },
};
